import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import Tooltip from 'bootstrap/js/src/tooltip';

export default { Tooltip };
